import { useAppDispatch, useAppSelector } from "@app/hooks";
import { useApi } from "@services/useApi";
import { appendTargetResponseNote } from "@store/assessmentResultSlice";
import { Note } from "@store/generalTypes";
import { NotesContainer } from "./notesContainer";

export const PresentTargetResultNotes = ({ notes, targetResponseId }: PresentTargetResultNotesProps): JSX.Element => {
    const assessmentResult = useAppSelector((x) => x.assessmentResult);
    const { createTargetResponseNote } = useApi();
    const dispatch = useAppDispatch();

    const handleOnCreateNote = async (note: Note): Promise<void> => {
        const noteId = await createTargetResponseNote(assessmentResult.id, targetResponseId, note.text);

        note.id = noteId.id;

        dispatch(appendTargetResponseNote({ id: targetResponseId, note }));

        return await Promise.resolve();
    };

    return <NotesContainer notes={notes} allowAddNote displayAddButtonOnHover onCreateNote={handleOnCreateNote} />;
};

interface PresentTargetResultNotesProps {
    notes?: Note[];
    targetResponseId: number;
}
